import { render, staticRenderFns } from "./OpzstatHeadIndex.vue?vue&type=template&id=2ca2e106&scoped=true"
import script from "./OpzstatHeadIndex.vue?vue&type=script&lang=js"
export * from "./OpzstatHeadIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca2e106",
  null
  
)

export default component.exports